import { useTranslation } from "react-i18next";
import { TableMenu } from "components";
import RCAConfirmDeleteModal from "pages/Corporate/RCA/components/RCAConfirmDeleteModal/RCAConfirmDeleteModal";
import { useMemo, useState } from "react";
import moment from "moment";
import { IOption } from "components/TableMenu/TableMenuInterfaces";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import useRolesPermissions from "hooks/useRolesPermissions";

const ActionPlanOptionsMenuCell = ({
    actionPlan,
    refetch,
}: {
    actionPlan: IActionPlan;
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
}) => {
    const { t } = useTranslation();
    const [openActionPlanDeleteModal, setOpenActionPlanDeleteModal] = useState<boolean>(false);
    const { updateActionPlanMutation } = ActionPlanEntity.UpdateActionPlan();

    const rcaOwnershipIds = useMemo(
        () =>
            actionPlan
                ? [
                      ...(actionPlan?.submitted_by_user_id ? [actionPlan.submitted_by_user_id] : []),
                      ...(actionPlan?.assignee ? [actionPlan.assignee.user_id] : []),
                      ...(actionPlan?.approver_id ? [actionPlan.approver_id] : []),
                      ...(actionPlan?.created_by ? [actionPlan?.created_by] : []),
                  ]
                : [],
        [actionPlan],
    );
    const { RCA_PERMISSIONS } = useRolesPermissions(rcaOwnershipIds);

    const handleDeleteActionPlan = async () => {
        const actionPlanDetailValues = {
            deleted_at: moment.utc().toDate(),
        };

        try {
            await updateActionPlanMutation({
                variables: {
                    actionPlanId: actionPlan?.action_plan_id,
                    changes: {
                        ...actionPlanDetailValues,
                    },
                },
            });
            refetch();
        } catch {
            return;
        }
    };

    const options: IOption[] = [
        {
            name: t("rca.action_plans.action_plan_details.delete_action_plan"),
            callback: () => setOpenActionPlanDeleteModal(true),
            disabled: !RCA_PERMISSIONS.action_plans.canDelete,
        },
    ];

    return (
        <div>
            <TableMenu options={options} />{" "}
            <RCAConfirmDeleteModal
                open={openActionPlanDeleteModal}
                onClose={() => setOpenActionPlanDeleteModal(false)}
                onDeleteItem={handleDeleteActionPlan}
                title={t("rca.action_plans.action_plan_delete_modal.title")}
                warning={t("rca.action_plans.action_plan_delete_modal.warning")}
                confirm={t("rca.action_plans.action_plan_delete_modal.confirm")}
            />
        </div>
    );
};

export default ActionPlanOptionsMenuCell;
